// External Dependencies:
import React from 'react'

// Internal Dependencies:
import Waypoint from 'components/Waypoint/Waypoint'

class ContactBall extends React.Component {
	constructor( props ) {
		super( props )

		this.circleRef = React.createRef()
		this.spotRef = React.createRef()
	}

	// componentDidMount() {

	// }

	// componentWillUnmount() {

	// }

	onEnter = () => {
		document.addEventListener( 'mousemove', this.throttledMouseMove )
	}

	onLeave = () => {
		document.removeEventListener( 'mousemove', this.throttledMouseMove )
	}

	throttledMouseMove = ( e ) => {
		requestAnimationFrame( () => {
			this.handleMouseMove( e )
		} )
	}

	handleMouseMove = ( e ) => {
		const mouseX = e.clientX
		const mouseY = e.clientY

		const bigCircleRect = this.circleRef.current.getBoundingClientRect()
		const offsetX = mouseX - bigCircleRect.left
		const offsetY = mouseY - bigCircleRect.top

		const centerX = bigCircleRect.width / 2
		const centerY = bigCircleRect.height / 2
		const distance = Math.sqrt( ( offsetX - centerX ) ** 2 + ( offsetY - centerY ) ** 2 )

		// Only update style when inside circle:
		if ( distance <= bigCircleRect.width / 2 ) {
			this.spotRef.current.style.transform = `translate( ${offsetX}px, ${offsetY}px )`
		}
	}

	render() {
		return (
			<div className="contact-ball">
				<Waypoint
					onEnter={ this.onEnter }
					onLeave={ this.onLeave }
				/>

				<a href="mailto:hello@merrynnethercote.com">
					<span className="-bg"></span>

					<span className="-circle" ref={ this.circleRef }>
						<span className="-spot" ref={ this.spotRef }></span>

						<span className="-inner">
							<span>Click to</span>
							<span>get in touch</span>
						</span>
					</span>
				</a>
			</div>
		)
	}
}


export default ContactBall



// WEBPACK FOOTER //
// ./components/Contact/ContactBall.jsx